import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const CREATE_YIELDBIRD_WORKSPACE_BIDDER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation createYieldbirdWorkspaceBidder($input: CreateYieldbirdWorkspaceBidderInput!) {
    result: createYieldbirdWorkspaceBidder(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
